import { Button } from "@material-ui/core";
import { useState } from "react";
import { ConnectedWalletIcon, DisconnectedWalletIcon } from "src/components/Icon";
import { formatAddress } from "src/services/utils";
import { useWeb3Connect } from "../../../wallet-connection/context/we3-connect-context";
import ConnectWalletDialog from "./ConnectWalletDialog";
import DisconnectedWalletDialog from "./DisconnectedWalletDialog";

export default function ConnectedButton({ ...props }) {
  const { address } = useWeb3Connect();

  const [isOpenConnect, setIsOpenConnect] = useState(false);
  const [isOpenDisconnect, setIsOpenDisconnect] = useState(false);

  const onConnectClick = () => {
    if (!address) setIsOpenConnect(true);
    else setIsOpenDisconnect(true);
  };

  return (
    <>
      <Button
        color="primary"
        variant="contained"
        startIcon={address ? <ConnectedWalletIcon /> : <DisconnectedWalletIcon />}
        disableElevation
        {...props}
        onClick={() => onConnectClick()}
      >
        {address ? `${formatAddress(address, 4)}` : "Connect wallet"}
      </Button>
      <ConnectWalletDialog open={isOpenConnect} onClose={() => setIsOpenConnect(false)} />
      <DisconnectedWalletDialog open={isOpenDisconnect} onClose={() => setIsOpenDisconnect(false)} />
    </>
  );
}
